import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { FcmNotification } from './../../../models/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ApiService } from 'src/app/providers/api.service';
import { InvoiceComponent } from '../invoice/invoice.component';
import { Observable, Subscription } from 'rxjs';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { COUNTRY_CODES } from '../../data/country-codes';
import { EmployeeAssignForServiceComponent } from '../employee-assign-for-service/employee-assign-for-service.component';
import { EmployeeAssignForCustomiseComponent } from '../employee-assign-for-customise/employee-assign-for-customise.component';
import { CalenderDialogComponent } from '../calender-dialog/calender-dialog.component';
import { SlotTimingsComponent } from 'src/app/pages/new-v2-pages/new-v2-component/slot-timings/slot-timings.component';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { debounceTime, filter, switchMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'sm-create-invoice',
  templateUrl: './create-invoice.component.html',
  styleUrls: ['./create-invoice.component.scss']
})
export class CreateInvoiceComponent implements OnInit, OnDestroy {
  countryInfo:any = typeof sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT) == 'string' ? JSON.parse(sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT)!) : sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT)
  isEntityForeign: string = localStorage.getItem(SM_CONSTANTS.IS_ENTITY_FOREIGN)!
  isEntityIndividual: string = sessionStorage.getItem('isEntityIndividual')!
  repeatArray:any = new Array(0)
  form: FormGroup;
  private _apiSubscription: Subscription = new Subscription();
  customiseBookingData: any = []
  employeeList:any = []
  employeeToAssign:any = []
  taxSlabData:any = []
  discountInfo: any = null;
  toShowEmployees: boolean = false;
  public newbookingData: any = {
    price: 0,
    discount: 0

  }
  selectedBookingType: number = 1
  serviceList: any = []
  productsList: any = []
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentData: any,    private fb: FormBuilder,private http: HttpClient,
    private _apiService: ApiService, private _modelRef: MatDialog, private loader: LoaderServiceService
  ) {
    this.form = this.fb.group({
      items: this.fb.array([])
    });
  }
  ngOnInit(): void {
    let dateobj = this.getOneHourSlot(new Date())
    this.startTime = dateobj.start
    this.endTime = dateobj.end

    console.log(this.parentData.data);
    this.discountInfo = this.parentData.data.discountInfo
    let data = this.parentData.data
    
    if(this.isEntityForeign == '0'){
      this._apiService.getEntityTaxSlabData(data.entityHash)
    }
    else if(this.isEntityForeign == '1'){
      this._apiService.getInternationalEntityTaxSlabsData(data.entityHash)
    }


    
    this._apiService.getServicesTypesList(data.entityHash,'0','0')
    this._apiService.getEntityProductList(data.entityHash,'1')

    // this._apiService.getBookingOperationDetails(data.bookingData.hash_id)

    // this._apiService.getEmployeeList(data.entityHash)

   this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
      console.log("inManageBookings:", resData)
      if(resData.responseType === SM_CONSTANTS.GET_SERVICES_TYPES_LIST_RESULT){
        console.log(resData);
       
        this.serviceList = [];
        if(resData.result){
            if (this.parentData.data.serviceType == '1') {
              resData.result.forEach((element: any) => {
                if (element.shopStatus == 1 && element.status == 1) {
                  element.toShow = true 
                  this.serviceList.push(element);
                }
              });
              // this.itemListData = data.result.filter((x: { shopStatus: number; })=>x.shopStatus == 1);
            } else if (this.parentData.data.serviceType == '0') {
              resData.result.forEach((element: any) => {
                if (element.homeStatus == 1 && element.status == 1){
                  element.toShow = true 
                  this.serviceList.push(element);
                } 
              });
              // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
            }
            else if (this.parentData.data.serviceType == '2') {
              resData.result.forEach((element: any) => {
                if (element.for_virtual == 1 && element.status == 1){
                  element.toShow = true 
                  this.serviceList.push(element);
                } 
              });
              // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
            }

        }

       


        this.checkCustomiseBookingData(this.customiseBookingData).then((value) => {
          // console.log("Customise booking data is available:", data);
          if(this.customiseBookingData[0].serviceInfo){
            this.customiseBookingData[0].serviceInfo.forEach((element:any) => {
              if(element.completed_by && element.completed_by != 'null'){
              const totalQty = element.completed_by.reduce((sum:any, data:any) => sum + data.competed_services_qty, 0);
              element.total_completed_services_qty = totalQty
              this.selectServices(element)
              }
            });
          }
          console.log(this.completedJobs);
          
         
        });
        
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_PRODUCT_LIST){
        console.log(resData);
       
        this.productsList = [];
        if(resData.result){

          if (this.parentData.data.serviceType == '1') {
            resData.result.forEach((element: any) => {
              if (element.shop_status == 1 && element.status == 1) {
                element.toShow = true 
                this.productsList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { shopStatus: number; })=>x.shopStatus == 1);
          } else if (this.parentData.data.serviceType == '0') {
            resData.result.forEach((element: any) => {
              if (element.home_status == 1 && element.status == 1){
                element.toShow = true 
                this.productsList.push(element);
              } 
            });
            // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
          }
          else if (this.parentData.data.serviceType == '2') {
            resData.result.forEach((element: any) => {
              if (element.virtual_status == 1 && element.status == 1){
                element.toShow = true 
                this.productsList.push(element);
              } 
            });
            // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
          }
        }
        
      
        
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_TAX_SLAB_DATA){
        this.taxSlabData = []
        if(resData.result){
      
          this.taxSlabData = resData.result.filter((item:any) => item.tax_collection_status == 1)
        }
        else{
          // this.isTaxApplicable = true
          // this.loaderservice.showLoader = false
        }
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_INTERNATIONAL_ENTITY_TAX_SLAB_DATA){
        this.taxSlabData = []
        if(resData.result){

          this.taxSlabData = resData.result.filter((item:any) => item.tax_collection_status == 1)

        }
        else{
          // this.isTaxApplicable = true
          // this.loaderservice.showLoader = false
        }
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_UPDATE_BOOKING_STATUS){
        if (resData.result) {
          this.parentData.ref.closeAll();


        } 
        
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_CUSTOMISE_BOOKING_DETAILS){
        if (resData.result) {
          this.parentData.ref.closeAll();
          if(!this.isPartial){
            this._modelRef.open(InvoiceComponent, {
              width: '510px',
              data: {
                title: 'Invoice',
                ref: this._modelRef,
                data: this.parentData.data.bookingData.hash_id
              },
            });
          }
          
        } 
        
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_BOOKING_OPERATION_DETAILS){
        this.customiseBookingData = []
        if (resData.result) {
          if(resData.result.serviceInfo){
            resData.result.serviceInfo = JSON.parse(resData.result.serviceInfo)
          }
          

          this.customiseBookingData.push(resData.result)
          this.newbookingData.customerName = this.customiseBookingData[0].customer_name
          // this.newbookingData.customerPh = (this.customiseBookingData[0].customer_phone && this.customiseBookingData[0].customer_phone != 'null' && this.customiseBookingData[0].customer_phone != '') ? this.customiseBookingData[0].customer_phone.slice(3) : ''
          this.newbookingData.customerPh = (
            this.customiseBookingData[0].customer_phone &&
            this.customiseBookingData[0].customer_phone !== 'null' &&
            this.customiseBookingData[0].customer_phone !== ''
          ) ? (
            this.customiseBookingData[0].customer_phone.slice(-10)
          ) : '';
          this.selectedCountryCode = this.countryList.find(country => country.dial_code === this.customiseBookingData[0].customer_phone.slice(0,-10) && country.code === this.countryInfo.code)
          this.newbookingData.discount =  this.customiseBookingData[0].discount
        } 
        
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_UPDATE_BOOKING_STATUS_WITH_INVOICE){
        if (resData.result) {
          this.parentData.ref.closeAll();

          this._modelRef.open(InvoiceComponent, {
            width: '510px',
            data: {
              title: 'Invoice',
              ref: this._modelRef,
              data: JSON.parse(resData.result).bookingHashId
            },
          });
        } 
        
      }
      // if(resData.responseType === SM_CONSTANTS.GET_EMPLOYEE_LIST_RESULT){
      //   this.employeeList = []
      //   if(resData.result){
      //     resData.result.forEach((element:any) => {
      //      if(element.isExEmployee != 1){
      //        this.employeeList.push(element)
      //      }
      //    });
      //   }
         
      //  }
    });
  }



  countryList: {name: string; dial_code: string; code: string; flag: string; preferred?: any;}[] = COUNTRY_CODES;
  selectedCountryCode:any = this.countryList.find(country => country.dial_code === this.countryInfo.countryCode&& country.code === this.countryInfo.code)
  searchString: FormControl = new FormControl('');
  onCountrySelected(event: any): void {
    this.searchString.reset()
    this.countryList = COUNTRY_CODES
  }
  
  onKey() { 
    console.log(this.searchString.value);
    
    this.countryList= []; 
    this.selectSearch(this.searchString.value);       
  }
  selectSearch(value:string){
    let filter = value.toLowerCase();
    for ( let i = 0 ; i < COUNTRY_CODES.length; i ++ ) {
        let option = COUNTRY_CODES[i];
        if (  option.name.toLowerCase().indexOf(filter) >= 0) {
            this.countryList.push( option );
        }
    }
  }


formChecker(){
  if(this.newbookingData.customerPh){
    if(this.newbookingData.customerPh.length >= 3 && this.newbookingData.customerPh.length <= 17){
      return false
    }
    else{
      return true
    }
  }
  else{
    return false
  }
}


  /**------------all done and generate bill--------------- */

  serviceInfo: any = []
  productInfo: any = []
  serviceInfoFinalise: any = []
  completedJobs2:any = []
  onPost() {
    this.completedServices = []
    this.productInfo = []
    this.completedJobs.forEach((element:any) => {
      const totalQty = element.completed_by.reduce((sum:any, data:any) => sum + data.competed_services_qty, 0);
      
        this.completedServices.push({
          service_hash_id: element.service_type_hash,
          service_name: element.service_name,
          description: element.description,
          img_url: element.img_url,
          approxTime: element.approxTime ? element.approxTime : 60,
          service_cost: element.price,
          current_status: 3,
          completed_by_hash_ids: element.completed_by.map((data:any) => {
            return {
              completedByHashId: data.completed_by_hash,
              qty: data.competed_services_qty,
              cost: data.cost
            }
          }),
          serviceQty: totalQty,
          "tax_slab_hash": element.tax_slab_hash, 
          "service_sac_code": element.service_sac_code
        })
  
      
     
    });


    this.productInfo = this.completedProducts.map((item:any) => {
      return {
        "product_name": item.product_name,
        "product_desc": item.description,
        "entity_product_hash": item.hash_id,
        "product_img_url": item.img_url,
        "product_price": item.price,
        "product_qty": item.total_completed_services_qty,
        "tax_slab_hash": item.tax_slab_hash,
        "hsn_code": item.hsn_code
      }
    })


    let data = {
      bookingStatusInfo : {
        appointmentHash: "",
        assignedToHash: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
        assignedByHash: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
        entityHash:  this.parentData.data.entityHash, 
        bookingStatus: 4,
        price: this.newbookingData.price.toString(),
        startTime: this.startTime,
        endTime: this.endTime,
        note: this.newbookingData.note ,
        completedServices: this.completedServices,
        products: this.productInfo,
        custom_items: this.form.get('items')!.value.map((item:any) => {
          return {
            "item_name": item.name.item_name ?  item.name.item_name : item.name, 
            "item_desc": item.name.item_desc ?? '', 
            "item_inventory_hash": item.name.hash_id ?? '', 
            "item_img_url": item.name.image_thumb_url ?? '', 
            "item_qty": item.count, 
            "item_price": +item.price,
            "tax_slab_hash": item.tax_slab == 'default' ? null : item.tax_slab
          }
        }),
        bookingDate: this.formatDateString(new Date(this.selectedDate ? this.selectedDate : this.today)),
        countryCode: this.selectedCountryCode.dial_code,
        customerPh: this.newbookingData.customerPh ? this.newbookingData.customerPh : '0000000000', 
        customerName: this.newbookingData.customerName ? this.newbookingData.customerName : 'New Customer',
        bookingType: this.parentData.data.serviceType,
        newCustomer: 1,
        discount: this.newbookingData.discount,

      }

      
    }
    Object.keys(data.bookingStatusInfo).forEach(key => {
      if ((data.bookingStatusInfo as any)[key] === null) {
        delete (data.bookingStatusInfo as any)[key];
      }
    });
    data.bookingStatusInfo.completedServices.forEach((element:any) => {
      Object.keys(element).forEach(key => {
        if ((element as any)[key] === null) {
          delete (element as any)[key];
        }
      });
      
    });
    data.bookingStatusInfo.products.forEach((element:any) => {
      Object.keys(element).forEach(key => {
        if ((element as any)[key] === null) {
          delete (element as any)[key];
        }
      });
      
    });
    data.bookingStatusInfo.custom_items.forEach((element:any) => {
      Object.keys(element).forEach(key => {
        if ((element as any)[key] === null) {
          delete (element as any)[key];
        }
      });
      
    });
    console.log(data);
    this.loader.showLoader = true
    this._apiService.updateBookingStatusWithInvoice(data)
  }

  today = new Date();
  selectedDate: any = null;
  onSelectDate () {
    const dialogRef = this._modelRef.open(CalenderDialogComponent, {
      width: "350px", 
      panelClass: 'calender-dialog-container',
      data: {
        selectedDate: this.today
      }
    });
    dialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
     

        this.selectedBookingType = 5
        this.selectedDate = data;
        console.log(this.today);
        
        // this.ngOnInit();
      }
    })
  }
/**-------------------partially done------------------- */
isPartial: boolean = false
  completedServices: any = []
  partiallyDone(){
    this.completedServices = []
    this.isPartial = true
    console.log(this.completedJobs)
    this.completedJobs2 = []
    // this.completedJobs.forEach((element:any) => {
    //   this.completedJobs2.push(element)
    // });
    if(this.customiseBookingData[0].serviceInfo){
      this.completedJobs.forEach((element:any) => {
        const totalQty = element.completed_by.reduce((sum:any, data:any) => sum + data.competed_services_qty, 0);
        this.completedServices.push({
          service_hash_id: element.service_type_hash,
          service_name: element.service_name,
          description: element.description,
          img_url: element.img_url,
          approxTime: element.approxTime ? element.approxTime : 60,
          completed_by_hash_ids: element.completed_by.map((data:any) => {
            return {
              completedByHashId: data.completed_by_hash,
              qty: data.competed_services_qty,
              cost: data.cost
            }
          }),
          service_cost: element.price,
          current_status: 3,
          serviceQty: totalQty
        })
      });
      // this.customiseBookingData[0].serviceInfo.forEach((element:any) => {
      //   const index = this.completedJobs2.findIndex( (x:any)=>x.service_type_hash == element.service_type_hash);
      //   console.log(index);
        
      //   if(index == -1){
      //     console.log(element);
          
      //     let data = {
      //       service_type_hash: element.service_type_hash,
      //       service_name: element.service_name,
      //       price: element.price,
      //       note: element.note,
      //       img_url: element.img_url,
      //       employee_name: element.employee_name,
      //       employee_hash_id: element.employee_hash_id,
      //       description: element.description,
      //       current_status: 3,
      //       isDelete: 1
      //     }
  
      //     this.completedJobs2.push(data)
      //   }
      // });

    }else {
      
    }
    

//     console.log(this.completedJobs2);
    
//     this.serviceInfoFinalise = []

//     this.completedJobs2.forEach((element:any) => {
//         this.serviceInfoFinalise.push({
//           service_hash_id: element.service_type_hash,
//           service_name: element.service_name,
//           description: element.description,
//           img_url: element.img_url,
//           approxTime: element.approxTime ? element.approxTime : 60,
//           completed_by_hash_ids: element.completed_by,
//           service_cost: element.price,
//           current_status: 3,
//           isDelete: element.isDelete ? element.isDelete : null
//         })
  
     
//     });

// this.serviceInfoFinalise.forEach((element:any) => {

//   Object.keys(element).forEach(key => {
//     if ((element as any)[key] === null) {
//       delete (element as any)[key];
//     }
//   });


// });


    let data = {
      appointmentHashId: this.parentData.data.bookingData.hash_id,
      customerName: this.newbookingData.customerName ? this.newbookingData.customerName : 'New Customer',
      customerHashId: this.customiseBookingData[0].customer_hash,
      net_payable: this.newbookingData.price - this.newbookingData.discount,
      totalPrice:  this.newbookingData.price, 
      booking_current_status: 9,
      customerPhone: this.newbookingData.customerPh ? this.selectedCountryCode.dial_code + this.newbookingData.customerPh : this.selectedCountryCode.dial_code +  '0000000000',
      discount: this.newbookingData.discount,
      servicesInfo: this.completedServices
    }

    console.log(data);
    this.loader.showLoader = true
    this._apiService.customizeBookingDetails(data)
  }

  allDoneAndRelease(){
    this.isPartial = true
    this.completedServices = []
    this.completedJobs2 = []
    this.completedJobs.forEach((element:any) => {
      this.completedJobs2.push(element)
    });
    if(this.customiseBookingData[0].serviceInfo){
      this.completedJobs.forEach((element:any) => {
        const totalQty = element.completed_by.reduce((sum:any, data:any) => sum + data.competed_services_qty, 0);
        this.completedServices.push({
          service_hash_id: element.service_type_hash,
          service_name: element.service_name,
          description: element.description,
          img_url: element.img_url,
          approxTime: element.approxTime ? element.approxTime : 60,
          completed_by_hash_ids: element.completed_by.map((data:any) => {
            return {
              completedByHashId: data.completed_by_hash,
              qty: data.competed_services_qty,
              cost: data.cost
            }
          }),
          service_cost: element.price,
          current_status: 3,
          serviceQty: totalQty
        })
      });
      // this.customiseBookingData[0].serviceInfo.forEach((element:any) => {
      //   const index = this.completedJobs2.findIndex( (x:any)=>x.service_type_hash == element.service_type_hash);
      //   console.log(index);
        
      //   if(index == -1){
      //     console.log(element);
          
      //     let data = {
      //       service_type_hash: element.service_type_hash,
      //       service_name: element.service_name,
      //       price: element.price,
      //       note: element.note,
      //       img_url: element.img_url,
      //       employee_name: element.employee_name,
      //       employee_hash_id: element.employee_hash_id,
      //       description: element.description,
      //       current_status: 3,
      //       isDelete: 1
      //     }
  
      //     this.completedJobs2.push(data)
      //   }
      // });

    }else {
      
    }
    

//     console.log(this.completedJobs2);
    
//     this.serviceInfoFinalise = []

//     this.completedJobs2.forEach((element:any) => {
//         this.serviceInfoFinalise.push({
//           service_hash_id: element.service_type_hash,
//           service_name: element.service_name,
//           description: element.description,
//           img_url: element.img_url,
//           approxTime: element.approxTime ? element.approxTime : 60,
//           completed_by_hash_id: element.employee_hash_id,
//           service_cost: element.price,
//           current_status: 3,
//           isDelete: element.isDelete ? element.isDelete : null
//         })
  
     
//     });

// this.serviceInfoFinalise.forEach((element:any) => {

//   Object.keys(element).forEach(key => {
//     if ((element as any)[key] === null) {
//       delete (element as any)[key];
//     }
//   });


// });


    let data = {
      appointmentHashId: this.parentData.data.bookingData.hash_id,
      customerName: this.newbookingData.customerName ? this.newbookingData.customerName : 'New Customer',
      customerHashId: this.customiseBookingData[0].customer_hash,
      net_payable: this.newbookingData.price - this.newbookingData.discount,
      totalPrice:  this.newbookingData.price, 
      booking_current_status: 4,
      customerPhone: this.newbookingData.customerPh ? this.selectedCountryCode.dial_code + this.newbookingData.customerPh : this.selectedCountryCode.dial_code +  '0000000000',
      discount: this.newbookingData.discount,
      servicesInfo: this.completedServices
    }

    console.log(data);
    this.loader.showLoader = true
    this._apiService.customizeBookingDetails(data)
  }
  changeChip(value:number){


 this.selectedDate = null
    this.selectedBookingType = value
    if(value == 1){
      this.selectedDate = new Date()
    }
    else if(value == 4){
      let tempDate = new Date()
      tempDate.setDate(tempDate.getDate() - 1);
      this.selectedDate = new Date(tempDate)
    }
    
  }
  completedJobs:any = []
  selectServices(item:any){
    console.log(item);
    if(item.service_type_hash){ // being added from api list
      console.log(item);
      
      const index = this.serviceList.findIndex( (x:any)=>x.hash_id == item.service_type_hash);
      console.log(index);

      if(index != -1){
       
        this.completedJobs.push(item)
        this.newbookingData.price += item.price
        
        this.serviceList[index].toShow = false
      }
      
      // this.serviceList[index].current_status = 3
     
      
    }


    else if(item.hash_id){ // being added from my list
      const index = this.serviceList.findIndex( (x:any)=>x.hash_id == item.hash_id);
    // this.completedJobs.push(this.serviceList[index])
    console.log(this.serviceList[index]);

    let data = {
      service_type_hash: item.hash_id,
      service_name: item.serviceName,
      price: (this.parentData.data.serviceType == '0') 
      ? (item.discountStatus == 1 ? item.homeDiscountedPrice : item.home_rate)
      : (this.parentData.data.serviceType == '1' ? (item.discountStatus == 1 ? item.shopDiscountedPrice : item.shop_rate)
      : (item.discountStatus == 1 ? item.virtual_discounted_amount : item.virtual_rate) ) ,
      note: item.note,
      img_url: item.imgUrl,
      completed_by: [{
        "cost": (this.parentData.data.serviceType == '0') 
        ? (item.discountStatus == 1 ? item.homeDiscountedPrice : item.home_rate)
        : (this.parentData.data.serviceType == '1' ? (item.discountStatus == 1 ? item.shopDiscountedPrice : item.shop_rate)
        : (item.discountStatus == 1 ? item.virtual_discounted_amount : item.virtual_rate)) ,
        "employee_name": localStorage.getItem(SM_CONSTANTS.OWNER_NAME) + '(Owner)',
        "completed_by_hash": localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
        "competed_services_qty": 1
    }],
      description: item.description,
      current_status: 3,
      total_completed_services_qty: 1,
      service_sac_code: item.service_sac_code,
      tax_slab_hash: item.tax_slab_hash
    }

    this.completedJobs.push(data)
    this.newbookingData.price += data.price
    this.serviceList[index].toShow = false
    }
    
    console.log("completedJobs:::", this.completedJobs);
    this.calculateDiscount()
  }
  completedProducts:any = []
  selectProducts(item:any){
    console.log(item);
    if(item.service_type_hash){ // being added from api list
      console.log(item);
      
      const index = this.serviceList.findIndex( (x:any)=>x.hash_id == item.service_type_hash);
      console.log(index);

      if(index != -1){
       
        this.completedJobs.push(item)
        this.newbookingData.price += item.price
        
        this.serviceList[index].toShow = false
      }
      
      // this.serviceList[index].current_status = 3
     
      
    }


    else if(item.hash_id){ // being added from my list
      const index = this.productsList.findIndex( (x:any)=>x.hash_id == item.hash_id);


    let data = {
      hash_id: item.hash_id,
      product_name: item.product_name,
      price: (this.parentData.data.serviceType == '0') 
      ? (item.discount_status == 1 ? item.home_discounted_price : item.home_price)
      : (this.parentData.data.serviceType == '1' ? (item.discount_status == 1 ? item.shop_discounted_price : item.shop_price)
      : (item.discount_status == 1 ? item.virtual_discounted_price : item.virtual_price) ) ,

      img_url: item.thumb_image_url,
    
      description: item.product_desc,
      total_completed_services_qty: 1,
      tax_slab_hash: item.tax_slab_hash,
      hsn_code: item.product_hsn_code,

    }

    this.completedProducts.push(data)
    this.newbookingData.price += data.price
    this.productsList[index].toShow = false
    }
    
    // console.log("completedJobs:::", this.completedJobs);
    this.calculateDiscount()
  }


  changeServicePrice(item:any){
    console.log(item.price);
    this.newbookingData.price = 0
    this.completedJobs.forEach((element:any) => {
      this.newbookingData.price += element.price
    });
    this.completedProducts.forEach((element:any) => {
      this.newbookingData.price += element.price
    });
    this.form.get('items')!.value.forEach((element:any) => {
      this.newbookingData.price += +(element.price)
    })
    
    this.checkIfEmpty()
    this.calculateDiscount()
  }
  changeProductPrice(item:any){
    console.log(item.price);
    this.newbookingData.price = 0
    this.completedJobs.forEach((element:any) => {
      this.newbookingData.price += element.price
    });
    this.completedProducts.forEach((element:any) => {
      this.newbookingData.price += element.price
    });
    this.form.get('items')!.value.forEach((element:any) => {
      this.newbookingData.price += +(element.price)
    })

    this.checkIfEmptyForProduct()
    this.calculateDiscount()
  }
  // removecompletedJobs(item:any){
  //   console.log(this.completedJobs);
    
  //   console.log(item);
    
  //   const index = this.serviceList.findIndex( (x:any)=>x.hash_id == item.service_type_hash);
  //   const index1 = this.completedJobs.findIndex( (x:any)=>x.service_type_hash == item.service_type_hash);

  //   console.log(index, index1);
    

  //   this.newbookingData.price -= this.completedJobs[index1].price
   

  //   this.serviceList[index].toShow = true
  //   this.completedJobs.splice(index1,1)
  // }

  selectEmployeeToAssign(item:any){
    this.employeeToAssign = []
    this.employeeList.forEach((element:any) => {
      element.selected = false
    });
    item.selected = true

    this.employeeToAssign.push(item)


    // this.selectedTopicHashId = item.hash_id
    // this.selectedTopicName = item.topic_name
  }

  assignEmployee(item:any, index:any){
    console.log(item);
    
    let dialogref = this._modelRef.open(EmployeeAssignForCustomiseComponent,{
      width: '600px',
      disableClose: true,
      data: {
        data: item,
        serviceType: this.parentData.data.serviceType
      }
    })

    dialogref.afterClosed().subscribe(res =>{
      if(res){
        console.log(res);
        
          this.completedJobs[index] = res
          console.log(this.completedJobs)
          if(!res.completed_by || res.completed_by.length == 0){
            const index1 = this.serviceList.findIndex( (x:any)=>x.hash_id == item.service_type_hash);
            this.serviceList[index1].toShow = true
            this.completedJobs.splice(index,1)
          }
          this.newbookingData.price = 0
          this.completedJobs.forEach((element:any) => {
            element.completed_by.forEach((item:any) => {
              this.newbookingData.price += item.cost
            });
          });
          this.calculateDiscount()
      }
    })
    // this.toAssignEmployeeService.employee_name = this.employeeToAssign[0].name
    // this.toAssignEmployeeService.employee_hash_id = this.employeeToAssign[0].employeeHashId
    // this.toShowEmployees = false
    // this.employeeToAssign = []
    // this.employeeList.forEach((element:any) => {
    //   element.selected = false
    // });
  }
  removeCompletedJobs(item:any){
    
    const index = this.serviceList.findIndex( (x:any)=>x.hash_id == item.service_type_hash);
    const index1 = this.completedJobs.findIndex( (x:any)=>x.service_type_hash == item.service_type_hash);

    this.newbookingData.price -= this.completedJobs[index1].price
    this.serviceList[index].toShow = true
    this.completedJobs.splice(index1,1)
    this.calculateDiscount()
  }
  removeCompletedProducts(item:any){
    
    const index = this.productsList.findIndex( (x:any)=>x.hash_id == item.hash_id);
    const index1 = this.completedProducts.findIndex( (x:any)=>x.hash_id == item.hash_id);

    this.newbookingData.price -= this.completedProducts[index1].price
    this.productsList[index].toShow = true
    this.completedProducts.splice(index1,1)
    this.calculateDiscount()
  }
  toAssignEmployeeService:any
  showEmployee(item:any){
    this.toAssignEmployeeService = item
    this.toShowEmployees = !this.toShowEmployees
  }
  hideEmployee(){
     this.toShowEmployees = !this.toShowEmployees
  }
  decreaseServiceCount(item:any,index:any){
    if(this.completedJobs[index].total_completed_services_qty == 1){
  
      const index1 = this.serviceList.findIndex( (x:any)=>x.hash_id == item.service_type_hash);

      this.newbookingData.price -= this.completedJobs[index].price/this.completedJobs[index].total_completed_services_qty
      this.serviceList[index1].toShow = true
      this.completedJobs.splice(index,1)
    }
    
    else{
    
  
      const index1 = item.completed_by.findIndex( (x:any)=> x.completed_by_hash == localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID));
      console.log(index1);
      
     
      
    
      // const index = this.serviceList.findIndex( (x:any)=>x.hash_id == item.hash_id);
      // const index1 = this.completedJobs.findIndex( (x:any)=>x.hash_id == item.hash_id);

      // let service_cost
      // if(this.parentData.data.serviceType == '0'){
      //   if(this.completedJobs[index].discountStatus == 1){
      //     service_cost = this.completedJobs[index].homeDiscountedPrice
      //     // this.newbookingData.price += this.completedJobs[index].homeDiscountedPrice
      //   }
      //   else if(this.completedJobs[index].discountStatus == 0){
      //     service_cost = this.completedJobs[index].home_rate
      //     // this.newbookingData.price += this.completedJobs[index].home_rate
      //   }
      // }
      // else if(this.parentData.data.serviceType == '1'){
      //   if(this.completedJobs[index].discountStatus == 1){
      //     service_cost = this.completedJobs[index].shopDiscountedPrice
      //     // this.newbookingData.price += this.completedJobs[index].shopDiscountedPrice
      //   }
      //   else if(this.completedJobs[index].discountStatus == 0){
      //     service_cost = this.completedJobs[index].shop_rate
      //     // this.newbookingData.price += this.completedJobs[index].shop_rate
      //   }
      // }

      this.newbookingData.price -= this.completedJobs[index].price/this.completedJobs[index].total_completed_services_qty
      if(index1 == -1){
        if(item.completed_by[item.completed_by.length-1].competed_services_qty == 1){
          item.completed_by.splice(item.completed_by.length-1,1)
        }
        else{
          item.completed_by[item.completed_by.length-1].competed_services_qty--;
          item.completed_by[item.completed_by.length-1].cost -= this.completedJobs[index].price/this.completedJobs[index].total_completed_services_qty
        }
        // item.completed_by.splice(item.completed_by.length-1,1)
      }
      else{
        if(item.completed_by[index1].competed_services_qty == 1){
          item.completed_by.splice(index1,1)
        }else{
  
          item.completed_by[index1].cost -= this.completedJobs[index].price/this.completedJobs[index].total_completed_services_qty 
          item.completed_by[index1].competed_services_qty -= 1 
        }
    
      }
  
      this.completedJobs[index].price -= this.completedJobs[index].price/this.completedJobs[index].total_completed_services_qty 
      this.completedJobs[index].total_completed_services_qty--
    }
    this.calculateDiscount()
  }


  increaseServiceCount(item:any,index:any){
    this.newbookingData.price += item.price/item.total_completed_services_qty
  
  
    const index1 = item.completed_by.findIndex( (x:any)=> x.completed_by_hash == localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID));
    console.log(index1);
    
   
    
  
    // const index = this.serviceList.findIndex( (x:any)=>x.hash_id == item.hash_id);
    // const index1 = this.completedJobs.findIndex( (x:any)=>x.hash_id == item.hash_id);

    // let service_cost
    // if(this.parentData.data.serviceType == '0'){
    //   if(this.completedJobs[index].discountStatus == 1){
    //     service_cost = this.completedJobs[index].homeDiscountedPrice
    //     // this.newbookingData.price += this.completedJobs[index].homeDiscountedPrice
    //   }
    //   else if(this.completedJobs[index].discountStatus == 0){
    //     service_cost = this.completedJobs[index].home_rate
    //     // this.newbookingData.price += this.completedJobs[index].home_rate
    //   }
    // }
    // else if(this.parentData.data.serviceType == '1'){
    //   if(this.completedJobs[index].discountStatus == 1){
    //     service_cost = this.completedJobs[index].shopDiscountedPrice
    //     // this.newbookingData.price += this.completedJobs[index].shopDiscountedPrice
    //   }
    //   else if(this.completedJobs[index].discountStatus == 0){
    //     service_cost = this.completedJobs[index].shop_rate
    //     // this.newbookingData.price += this.completedJobs[index].shop_rate
    //   }
    // }
  
    if(index1 == -1){
      item.completed_by.push({
        "cost": item.price,
        "employee_name": localStorage.getItem(SM_CONSTANTS.OWNER_NAME) + '(Owner)',
        "completed_by_hash": localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
        "competed_services_qty": 1
    })
    }
    else{
  
      item.completed_by[index1].cost += item.price/item.total_completed_services_qty
      item.completed_by[index1].competed_services_qty += 1 
  
    }
    item.price += item.price/item.total_completed_services_qty 
    item.total_completed_services_qty++
    this.calculateDiscount()
  }
  decreaseProductCount(item:any,index:any){
    if(this.completedProducts[index].total_completed_services_qty == 1){
  
      const index1 = this.productsList.findIndex( (x:any)=>x.hash_id == item.hash_id);
      // console.log(this.productsList[index].price);
      // console.log(this.completedProducts[index].total_completed_services_qty);
      // console.log(this.newbookingData.price);
      
      this.newbookingData.price -= this.completedProducts[index].price/this.completedProducts[index].total_completed_services_qty
      this.productsList[index1].toShow = true
      this.completedProducts.splice(index,1)
    }
    
    else{
    


      this.newbookingData.price -= this.completedProducts[index].price/this.completedProducts[index].total_completed_services_qty

       
      this.completedProducts[index].price -= this.completedProducts[index].price/this.completedProducts[index].total_completed_services_qty 
      this.completedProducts[index].total_completed_services_qty--
    }
    this.calculateDiscount()
  }


  increaseProductCount(item:any,index:any){
    this.newbookingData.price += item.price/item.total_completed_services_qty
  


    item.price += item.price/item.total_completed_services_qty 
    item.total_completed_services_qty++
    this.calculateDiscount()
  }
  formatTime(date: Date): string {
    const hours = date.getHours().toString().padStart(2, '0'); // Ensure two digits, pad with leading zero if necessary
    const minutes = date.getMinutes().toString().padStart(2, '0'); // Same for minutes
    return `${hours}:${minutes}`;
}

checkCustomiseBookingData(customiseBookingData: any): Promise<any> {
  console.log("hitting");
  
  return new Promise((resolve) => {
    const intervalId = setInterval(() => {
      // console.log("hitting");
      if (customiseBookingData && customiseBookingData.length > 0) {
        clearInterval(intervalId);
        resolve(customiseBookingData);
      }
    }, 100); // interval time (adjust as needed)
  });
}
emptyCheck: boolean = false
checkIfEmpty(){
  this.completedJobs.forEach((element:any) => {
    if(!element.price|| element.price == ''){
      
      this.emptyCheck = true
    }else {
      this.emptyCheck = false
    }
  });
  console.log(this.emptyCheck);
  
}
emptyCheckForProduct: boolean = false
checkIfEmptyForProduct(){
  this.completedProducts.forEach((element:any) => {
    if(!element.price|| element.price == ''){
      
      this.emptyCheckForProduct = true
    }else {
      this.emptyCheckForProduct = false
    }
  });
  
}

addOneHourAndFormat(date: Date): string {
  const newDate = new Date(date);
  newDate.setHours(date.getHours() + 1);

  const hours = newDate.getHours().toString().padStart(2, '0');
  const minutes = newDate.getMinutes().toString().padStart(2, '0');

  return `${hours}:${minutes}`;
}

formatDateString(inputDateString: Date): string {
  const inputDate = new Date(inputDateString);
  const year = inputDate.getFullYear();
  const month = (inputDate.getMonth() + 1).toString().padStart(2, '0'); // Month is 0-indexed
  const day = inputDate.getDate().toString().padStart(2, '0');
  const hours = inputDate.getHours().toString().padStart(2, '0');
  const minutes = inputDate.getMinutes().toString().padStart(2, '0');
  const seconds = inputDate.getSeconds().toString().padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}
startTime:any = null
endTime:any = null
onSelectSlot(){
  this.loader.showLoader = true
  let dialogref = this._modelRef.open(SlotTimingsComponent, {
    data:{
      isToday: this.selectedBookingType == 1 ? true : false,
      day: this.selectedDate ? new Date(this.selectedDate).getDay() + 1 : new Date(this.today).getDay() + 1,
      entityHash: "jjjj",
      serviceType: this.parentData.data.serviceType
    }
  })
  dialogref.afterClosed().subscribe(res => {
    if(res){
      this.startTime = res.startTime
      this.endTime = res.endTime
    }
  })
}
tConv24(time24: any) {
  let ts: any = time24;
  let H: any = +ts.substr(0, 2);
  let h: any = H % 12 || 12;
  h = h < 10 ? '0' + h : h; // leading 0 at the left for 1 digit hours
  var ampm = H < 12 ? ' AM' : ' PM';
  ts = h + ts.substr(2, 3) + ampm;
  return ts;
}
getOneHourSlot(date:Date) {
  // Convert to local time string in 24-hour format
  const localTimeString = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });

  // Get hours and minutes
  let [hours, minutes] = localTimeString.split(':').map(Number);

  // Adjust hours based on minutes (round down to nearest hour)
  let startHour = hours;

  // Calculate next hour
  let endHour = (startHour + 1) % 24;

  // Format hours to always be 2 digits (e.g., 08:00, 23:00)
  const formatHour = (hour:any) => hour.toString().padStart(2, '0');

  // Return the 1-hour slot in 24-hour format
  return {
    start: `${formatHour(startHour)}:00`,
    end: `${formatHour(endHour)}:00`
  };
}

calculateDiscount(){
  this.newbookingData.discount = 0
  
  if (this.discountInfo.discountStatus == 1) {
    if (
      this.isCurrentDateInRange(
        this.discountInfo.start_date,
        this.discountInfo.end_date
      )
    ) {
      // percentage discount
      if (this.discountInfo.discountType == 1) {
        if (this.newbookingData.price >= this.discountInfo.minBillAmount) {
          // home service
          if (this.parentData.data.serviceType == "0") {
            if (this.discountInfo.home_service_status == 1) {
              let cal_disc =
                (+this.discountInfo.discountAmount / 100) *
                +this.newbookingData.price;
              if (cal_disc >= this.discountInfo.maxDiscount) {
                this.newbookingData.discount = this.discountInfo.maxDiscount;
              } else {
                this.newbookingData.discount = cal_disc;
              }
            }
          }
          // shop service
          else if (this.parentData.data.serviceType == "1") {
            if (this.discountInfo.shop_service_status == 1) {
              let cal_disc =
                (+this.discountInfo.discountAmount / 100) *
                +this.newbookingData.price;
              console.log(cal_disc);

              if (cal_disc >= this.discountInfo.maxDiscount) {
                this.newbookingData.discount = this.discountInfo.maxDiscount;
              } else {
                this.newbookingData.discount = cal_disc;
              }
            }
          }
          // virtual service
          else if (this.parentData.data.serviceType == "2") {
            if (this.discountInfo.virtual_service_status == 1) {
              let cal_disc =
                (+this.discountInfo.discountAmount / 100) *
                +this.newbookingData.price;
              console.log(cal_disc);

              if (cal_disc >= this.discountInfo.maxDiscount) {
                this.newbookingData.discount = this.discountInfo.maxDiscount;
              } else {
                this.newbookingData.discount = cal_disc;
              }
            }
          }
        }
      }
      // amount discount
      else if (this.discountInfo.discountType == 2) {
        if (this.newbookingData.price >= this.discountInfo.minBillAmount) {
          // home service
          if (this.parentData.data.serviceType == "0") {
            if (this.discountInfo.home_service_status == 1) {
              this.newbookingData.discount = this.discountInfo.discountAmount;
            }
          }
          // shop service
          else if (this.parentData.data.serviceType == "1") {
            if (this.discountInfo.shop_service_status == 1) {
              this.newbookingData.discount = this.discountInfo.discountAmount;
            }
          }
          // virtual service
          else if (this.parentData.data.serviceType == "2") {
            if (this.discountInfo.virtual_service_status == 1) {
              this.newbookingData.discount = this.discountInfo.discountAmount;
            }
          }
        }
      }
    }
  }

  this.newbookingData.discount = +this.newbookingData.discount.toFixed(2) 
}

isCurrentDateInRange(start_date: string, end_date: string): boolean {
  const currentDate = new Date();
  const startDate = new Date(start_date);
  const endDate = new Date(end_date);

  // Normalize the dates by setting the time to 00:00:00
  const normalizeDate = (date: Date): Date => {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  };

  const normalizedCurrentDate = normalizeDate(currentDate);
  const normalizedStartDate = normalizeDate(startDate);
  const normalizedEndDate = normalizeDate(endDate);

  // Check if the current date is between start and end date (inclusive)
  return normalizedCurrentDate >= normalizedStartDate && normalizedCurrentDate <= normalizedEndDate;
}

// addFormField(){
//   this.repeatArray.length++
// }

// removeFormField(index:any){
//   this.repeatArray.splice(index,1)
// }


// Create a new form group for each item
itemOptions: string[] = ['Item1', 'Item2', 'Item3', 'Item4'];  // List of options
  filteredOptions: Observable<any[]>[] = [];
createItem(): FormGroup {
  const itemGroup = this.fb.group({
    name: ['', Validators.required],
    price: ['', Validators.required],
    count: [1, Validators.required],
    tax_slab: ['default']
  });

  const filterControl = itemGroup.get('name') as FormControl;

  // Listen for changes, trigger API call if length > 3
  // const filteredOption = filterControl.valueChanges.pipe(
  //   debounceTime(300),  // Add debounce to reduce API calls
  //   filter(value => value.length > 2),  // Only call API if input length > 3
  //   switchMap(value => this.fetchOptions(value))  // Fetch options from API
  // );

  
  const priceControl = itemGroup.get('price') as FormControl;

  // Store the previous value to subtract when the value changes
  let previousPrice = 0;
  
  priceControl.valueChanges.subscribe(value => {
  // Convert the input value to a number
  const parsedValue = +value;
  if (!isNaN(parsedValue) && value !== '' && value !== undefined) {
      // Subtract the previous price before adding the new one
      this.newbookingData.price = this.newbookingData.price - previousPrice + (+value);
  
      // Update the previous price to the new value for future changes
      previousPrice = +value;
    }
    else{

    }

    this.calculateDiscount()
  });

  // this.filteredOptions.push(filteredOption);
  // console.log(this.filteredOptions);
  
  return itemGroup;
  
}

displayItemName(item: any): string {
  return item ? item.item_name : '';  // Return only the item_name for display
}

  // Call the API to fetch options based on the user's input
  fetchOptions(value: string): Observable<string[]> {
    // Example API call: Replace with your actual API endpoint
    return this.http.get<string[]>(`https://user-services.lookzup.com/dev/getInventoryDataByKeyword?entityHashId=${this.parentData.data.entityHash}&searchKey=${value}&pageNo=1&count=25`);
  }

  // Filter the autocomplete options based on the user's input
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.itemOptions.filter(option => option.toLowerCase().includes(filterValue));
  }

// Get the form array of items
get items(): FormArray {
  return this.form.get('items') as FormArray;
}

// Add new form field
addFormField(): void {
  this.items.push(this.createItem());
}

// Remove a form field by index
removeFormField(index: number): void {
  this.newbookingData.price -= +this.items.at(index).value.price
  
    
  this.items.removeAt(index);
  this.calculateDiscount()
}

  // Decrease the count and remove the form if count becomes 0
  decreaseCount(index: number): void {
    const currentItem = this.items.at(index);
    const currentCount = currentItem.get('count')!.value;

    if (currentCount > 1) {
      currentItem.get('count')!.setValue(currentCount - 1);
    } else {
      // this.newbookingData.price -= +currentItem.get('price')!.value
      this.removeFormField(index);  // Remove the form when count is 0

    }
    
  }

  // Increase the count
  increaseCount(index: number): void {
    const currentItem = this.items.at(index);
    currentItem.get('count')!.setValue(currentItem.get('count')!.value + 1);
  }
  

ngOnDestroy(): void {
  this._apiSubscription.unsubscribe()
 this.newbookingData = {
    price: 0

  }
}

}

